import { Method } from 'axios';
import { pickBy } from 'lodash';
import { axiosService } from '../services';
import { BasicParams, useCreateMutation } from '../CRUD';

type TMutationCreatorProps = {
  key: string;
  url: string;
  method: Method;
  params: BasicParams;
};

export const usePageMutationCreator = <GenericType>({
  key,
  url,
  method,
  params,
}: TMutationCreatorProps) => {
  async function queryFn(fetchParams: object) {
    const { data } = await axiosService({
      method,
      url: `/v2/pages/${url}`,
      data: {
        ...pickBy(fetchParams, (param) => param),
      },
    });
    return data.response as GenericType;
  }

  return useCreateMutation([key, url, params], queryFn, key);
};
